

const initialState = {
  isLoading: false,
  fees: {},
  newUser: {},
  currentData: {},
  details: {},
  errors: null,
};

const feesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "fees_List_req":
      return {
        ...state,
        isLoading: true,
      };
    case "fees_List_Success":
      return {
        ...state,
        isLoading: false,

        fees: action.payload,
      };
    case "fees_List_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "fees_req_delete":
      return {
        ...state,
        isLoading: true,
      };
    case "fees_delete":
      return {
        ...state,
        isLoading: false,

        fees: action.payload,
      };
    case "fees_delete_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "add_fees_req":
      return {
        ...state,
        isLoading: true,
      };
    case "add_fees_success":
      return {
        ...state,
        isLoading: false,

        newUser: action.payload,
      };
    case "add_fees_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "edit_fees_req":
      return {
        ...state,
        isLoading: true,
      };
    case "edit_fees_success":
      return {
        ...state,
        isLoading: false,

        newUser: action.payload,
      };

    case "edit_fees_failure":
      return {
        ...state,
        isLoading: false,

        errors: action.payload,
      };
    case "set_fees_details":
      return {
        ...state,
        laoding: false,
        currentData: action.payload,
      };
    case "reset_fees_details":
      return {
        ...state,
        laoding: false,
        currentData: {},
      };

    default:
      return state;
  }
};

export { feesReducer };
